import { render, staticRenderFns } from "./RemoveProfileModal.vue?vue&type=template&id=6e306f3c&scoped=true&"
import script from "./RemoveProfileModal.vue?vue&type=script&lang=js&"
export * from "./RemoveProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveProfileModal.vue?vue&type=style&index=0&id=6e306f3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e306f3c",
  null
  
)

export default component.exports